import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleLegalPageClick = () => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="footer-wrapper">
      <div className="footer-content">
        <p>&copy; {currentYear} Morph Technologies. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy-policy" onClick={handleLegalPageClick}>Privacy Policy</Link>
          <Link to="/terms-conditions" onClick={handleLegalPageClick}>Terms and Conditions</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
